import { query } from "./calls";

export const AccountList = {
    getById: (id) => query(`SELECT * FROM AccountList WHERE id=${id}`),
    getByIds: (id) => query(`SELECT * FROM AccountList WHERE id in (${id.toString()})`),
    searchAccount: (q) => query(`SELECT * FROM AccountList WHERE name like '${q}'`),
};
